import React from 'react';
import { FaEnvelope, FaPhone, FaLinkedin, FaGithub } from 'react-icons/fa';

const Contact = ({ contact, language }) => {
  const contactItems = [
    {
      icon: <FaEnvelope className="text-3xl mb-3 text-[#04c7e1] group-hover:text-white transition-colors" />,
      label: 'Email',
      value: contact.email,
      href: `mailto:${contact.email}`,
      color: 'hover:border-[#04c7e1]/50 hover:shadow-[#04c7e1]/20'
    },
    {
      icon: <FaPhone className="text-3xl mb-3 text-[#f2852d] group-hover:text-white transition-colors" />,
      label: 'Telefon',
      value: contact.phone,
      href: contact.phone ? `tel:${contact.phone.replace(/\s/g, '')}` : null,
      color: 'hover:border-[#f2852d]/50 hover:shadow-[#f2852d]/20',
      condition: !!contact.phone
    },
    {
      icon: <FaLinkedin className="text-3xl mb-3 text-[#0077b5] group-hover:text-white transition-colors" />,
      label: 'LinkedIn',
      value: 'Profil LinkedIn',
      href: contact.linkedin,
      color: 'hover:border-[#0077b5]/50 hover:shadow-[#0077b5]/20'
    },
    {
      icon: <FaGithub className="text-3xl mb-3 text-gray-400 group-hover:text-white transition-colors" />,
      label: 'GitHub',
      value: 'Profil GitHub',
      href: contact.github,
      color: 'hover:border-gray-500/50 hover:shadow-gray-500/20'
    }
  ];

  return (
    <section id="contact" className="section">
      <div className="container mx-auto">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6 text-gradient">
            {language === 'pl' ? 'Kontakt' : 'Contact'}
          </h2>
          <p className="mb-12 text-lg text-gray-300">
            {language === 'pl' 
              ? 'Masz pomysł na projekt? Potrzebujesz wsparcia IT? Skontaktuj się ze mną!' 
              : 'Have a project in mind? Need IT support? Get in touch!'}
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {contactItems.map((item, index) => (
              item.condition !== false && (
                <a 
                  key={index}
                  href={item.href}
                  target={item.label === 'Email' || item.label === 'Telefon' ? '_self' : '_blank'}
                  rel="noopener noreferrer"
                  className={`group flex flex-col items-center justify-center p-8 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:bg-white/10 hover:shadow-lg ${item.color}`}
                >
                  <div className="p-4 rounded-full bg-white/5 mb-4 group-hover:scale-110 transition-transform duration-300">
                    {item.icon}
                  </div>
                  <span className="text-gray-400 text-sm font-medium uppercase tracking-wider mb-2 group-hover:text-gray-300">{item.label}</span>
                  <span className="text-xl md:text-2xl font-bold text-white break-words w-full px-4">{item.value}</span>
                </a>
              )
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;

